/* ==========================================================================
   SHIRTPLUS | Kartenbild „Modelfoto vorn, Hover = Zufallsfarbe“ (20.10.2026)
   assets/sp-card-modell.js – gehoert zu snippets/sp-card-modell.liquid
   Wuerfelt bei jedem Seitenaufruf die Farben neu (nie Black):
   - Karte mit Modelfoto: Hover-Bild = eine zufaellige Farbe
   - Karte ohne Modelfoto: vorn eine zufaellige Farbe, Hover eine zweite
   Auch fuer Karten, die per Filter/Seitenwechsel nachgeladen werden.
   ========================================================================== */
(function () {
  if (window.__spCardModell) return;
  window.__spCardModell = true;

  function shuffle(list) {
    var a = list.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function apply(img, c) {
    if (!img || !c) return;
    img.setAttribute('srcset', c.s);
    img.setAttribute('src', c.u);
    if (c.a) img.setAttribute('alt', c.a);
  }

  function run() {
    var figs = document.querySelectorAll('[data-sp-mm]:not([data-sp-mm-done])');
    for (var n = 0; n < figs.length; n++) {
      var f = figs[n];
      f.setAttribute('data-sp-mm-done', '');
      var list;
      try { list = JSON.parse(f.getAttribute('data-sp-mm-colors') || '[]'); } catch (e) { continue; }
      if (!list.length) continue;
      var pick = shuffle(list);
      var main = f.querySelector('[data-sp-mm-main]');
      var hover = f.querySelector('[data-sp-mm-hover]');
      if (main) {
        apply(main, pick[0]);
        if (hover && pick[1]) apply(hover, pick[1]);
      } else if (hover) {
        apply(hover, pick[0]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  new MutationObserver(function () { run(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
